import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { BasicForm } from '@components/basic'
import { IBasicForm } from '@/const/types/form'
import { required } from '@vuelidate/validators'

interface Props {
    isLoading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginFormDomain',
  props: {
    isLoading: { type: Boolean, default: false }
  },
  emits: ["onSubmit"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'onSubmit', inputsValues: object): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isLoading: boolean };




const schema: IBasicForm = {
    name: 'Login user details form.',
    inputs: [
        {
            name: 'workingMode',
            label: 'Working mode',
            type: 'basicSelect',
            props: {
                elements: [
                    {
                        label: 'dev',
                        value: 'dev.api'
                    },
                    {
                        label: 'prod',
                        value: 'api',
                    }
                ],
                modelValue: 'dev.api',
                ariaLabel: 'workingMode',
            }
        },
        {
            name: 'wmsName',
            label: 'Name of WMS',
            type: 'basic',
            validation: { required },
        },
    ],
    handlers: {
        onSuccess(inputsValues) {
            emit('onSubmit', inputsValues);
        }
    },
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BasicForm), {
    schema: schema,
    "is-loading": props.isLoading
  }, null, 8, ["is-loading"]))
}
}

})